module.exports = __webpack_public_path__ + "img/218M带纸顶.232.608af621.png";